// extracted by mini-css-extract-plugin
export var brand = "_81-9";
export var compact = "_81-6";
export var extraSmall = "_81-7";
export var icon = "_81-0";
export var large = "_81-4";
export var light = "_81-1";
export var medium = "_81-5";
export var outline = "_81-b";
export var primaryDark = "_81-a";
export var primaryLight = "_81-8";
export var primaryModern = "_81-c";
export var success = "_81-2";
export var successSolid = "_81-3";